module.exports = __webpack_public_path__ + "static/media/defaultPropertyImage.cbbfc8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultPropertyImage.png
// module id = 171
// module chunks = 0